import api from '../../../api/index';

export default {
  save({ rootGetters }, fields) {
    return api.post('/admin/banner', fields, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getById({ rootGetters }, bannerId) {
    return api.get(`/admin/banner/${bannerId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  deleteBanner({ rootGetters }, bannerId) {
    return api.delete(`/admin/banner/${bannerId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  listBanners({ rootGetters }) {
    return api.get('admin/banner/all', {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getBannersByUser({}, data) {
    return api.get(`/user/banners/${data.userId}/${data.userType}`);
  },
};
